export enum InputAutoComplete {
    Off = 'off',
    NewPassword = 'new-password',
}
